import { render, staticRenderFns } from "./menu_page.vue?vue&type=template&id=7b873f45&scoped=true"
import script from "./menu_page.vue?vue&type=script&lang=js"
export * from "./menu_page.vue?vue&type=script&lang=js"
import style0 from "./menu_page.vue?vue&type=style&index=0&id=7b873f45&lang=scss&scoped=true"
import style1 from "./menu_page.vue?vue&type=style&index=1&id=7b873f45&scoped=true&lang=scss"
import style2 from "./menu_page.vue?vue&type=style&index=2&id=7b873f45&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b873f45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b873f45')) {
      api.createRecord('7b873f45', component.options)
    } else {
      api.reload('7b873f45', component.options)
    }
    module.hot.accept("./menu_page.vue?vue&type=template&id=7b873f45&scoped=true", function () {
      api.rerender('7b873f45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/menu_page.vue"
export default component.exports